import TypographyParagraph from '../typography/TypographyParagraph'
import Image from '../content/Image'
// @ts-ignore
import { FarcasterEmbed } from 'react-farcaster-embed/dist/client'

const Cast = ({
	metadata,
	asCountersign = false,
	displayEmbedContent = true,
}: {
	metadata: any
	asCountersign?: boolean
	displayEmbedContent?: boolean
}) => {
	return (
		<div className="flex flex-col">
			{metadata.properties.description && (
				<div
					className={`${asCountersign ? 'border-b border-textInactiveLight px-4 py-2 dark:border-textInactiveDark' : 'mb-4'}`}
				>
					<TypographyParagraph
						size="medium"
						isBold={true}
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{metadata.properties.description}
					</TypographyParagraph>
				</div>
			)}
			{displayEmbedContent ? (
				<div
					className={`w-full ${asCountersign ? 'px-4' : ''} dark:text-textPrimaryDark`}
				>
					<FarcasterEmbed url={metadata.properties.url} />
				</div>
			) : (
				<Image
					className="w-4/5 rounded-md"
					imageUrl={metadata.properties.ipfsCID}
					imageAlt={metadata.properties.url}
				/>
			)}
		</div>
	)
}

export default Cast
